import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
// import { HelperToolsService } from './helper-tools.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class isLoggedIn {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Promise<boolean>((resolve, reject) => {
      let token = this.auth.currentUserSubject?.value.access_token;
      if (token) {
        this.router.navigate(['/teams']);
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }
}
